import React from "react";
import {NavColumn, NavLabel, NavLinkItem, Sidebar} from "./ServiceNav.styles";
import {ServiceNavGroup} from "./ServiceNavGroup";

const isServiceNavGroupChild = (child: React.ReactElement) => {
    if (child.type === ServiceNavGroup) {
        return true;
    }
    const type = child.type as {displayName?: string};
    return type?.displayName === "ServiceNavGroup";
};

const isNavLinkChild = (child: React.ReactElement) =>
    React.isValidElement<{to?: string}>(child) && typeof child.props.to === "string";

const ServiceNav = ({label, children}: {label: string} & React.PropsWithChildren) => {
    const enhancedChildren = React.Children.map(children, (child, index) => {
        if (!React.isValidElement(child)) {
            return child;
        }
        if (isServiceNavGroupChild(child)) {
            return child;
        }
        if (isNavLinkChild(child)) {
            const {to, ...rest} = child.props as {to: string; [key: string]: unknown};
            return <NavLinkItem to={to} {...rest} key={child.key || `child-${index}`} />;
        }
        return child;
    });
    return (
        <Sidebar>
            <NavColumn>
                <NavLabel data-testid="service-nav-title">{label}</NavLabel>
                {enhancedChildren}
            </NavColumn>
        </Sidebar>
    );
};

export default ServiceNav;
export {ServiceNav};
export {ServiceNavGroup} from "./ServiceNavGroup";
